<div class="success-container">
  <div class="success-content">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-card">
      <mat-spinner diameter="60"></mat-spinner>
      <h2>{{statusMessage}}</h2>
      <p>Please wait while we complete your registration.</p>
    </div>

    <div *ngIf="!isLoading && recoveryNeeded" class="processing-card" role="status">
      <mat-icon>schedule</mat-icon>
      <h2>{{statusMessage}}</h2>
      <p>You do not need to pay again. Try checking the registration status again, or return later if it is still processing.</p>
      <button mat-flat-button color="primary" type="button" (click)="retryVerification()">Check again</button>
      <a mat-stroked-button [routerLink]="['/']">Back to home</a>
    </div>

    <!-- Success State -->
    <div *ngIf="!isLoading && registrationComplete" class="success-card">
      <div class="success-icon-wrapper">
        <mat-icon class="success-icon">check_circle</mat-icon>
      </div>
      
      <h1 class="success-title">Payment Successful!</h1>
      <h2 class="success-subtitle">{{registrationType === 'player' ? 'Player Registration Complete' : 'Team Registration Complete'}}</h2>
      <p class="success-note">Your payment was confirmed and the registration record has been updated.</p>
      
      <div class="success-details">
        <!-- Registration Summary -->
        <mat-card class="summary-card">
          <mat-card-content>
            <h3 class="summary-title"><mat-icon>receipt_long</mat-icon> Registration Summary</h3>
            
            <div class="summary-grid">
              <!-- Team Registration Fields -->
              <ng-container *ngIf="registrationType === 'team'">
                <div class="summary-item">
                  <span class="summary-label">Team Name</span>
                  <span class="summary-value team-name">{{teamName}}</span>
                </div>
                
                
                <div class="summary-item" *ngIf="divisionName">
                  <span class="summary-label">Division</span>
                  <span class="summary-value">{{divisionName}}</span>
                </div>
              </ng-container>
              
              <!-- Player Registration Fields -->
              
              <!-- Common Fields -->
              <div class="summary-item">
                <span class="summary-label">Season</span>
                <span class="summary-value">{{season}}</span>
              </div>
              
              <div class="summary-item" *ngIf="jerseyQuantity > 0">
                <span class="summary-label">Jerseys Ordered</span>
                <span class="summary-value">{{jerseyQuantity}}</span>
              </div>
              
              <div class="summary-item">
                <span class="summary-label">Payment Type</span>
                <span class="summary-value">{{paymentType === 'full' ? 'Full Payment' : 'Deposit'}}</span>
              </div>
              
              <div class="summary-item highlight">
                <span class="summary-label">Amount Paid</span>
                <span class="summary-value amount">${{amountPaid.toFixed(2)}}</span>
              </div>
            </div>
            
            <div class="email-notice"><mat-icon>email</mat-icon><span>A confirmation has been sent to your signed-in email address.</span></div>
          </mat-card-content>
        </mat-card>
        
        <!-- Next Steps -->
        <mat-card class="next-steps-card">
          <mat-card-content>
            <div class="next-steps">
              <h3><mat-icon>info</mat-icon> What's Next?</h3>
              <ul *ngIf="registrationType === 'team'">
                <li><mat-icon>email</mat-icon> Check your email for a confirmation with payment receipt</li>
                <li><mat-icon>group</mat-icon> Start recruiting your team members and build your roster</li>
                <li><mat-icon>calendar_today</mat-icon> Watch for the season schedule announcement</li>
                <li><mat-icon>sports_basketball</mat-icon> Get ready for an amazing season!</li>
              </ul>
              <ul *ngIf="registrationType === 'player'">
                <li><mat-icon>email</mat-icon> Check your email for a confirmation with payment receipt</li>
                <li><mat-icon>person</mat-icon> Your player profile has been created successfully</li>
                <li><mat-icon>calendar_today</mat-icon> Watch for the season schedule announcement</li>
                <li><mat-icon>sports_basketball</mat-icon> Get ready for an amazing season!</li>
              </ul>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="success-actions">
        <a mat-flat-button color="primary" [routerLink]="['/']">Back to home</a>
      </div>
      
    </div>
  </div>
</div>



